import type { ReadonlyURLSearchParams } from 'next/navigation'
import { env } from '@/env/client'

export function getUrlWithParams(
  pathname: string,
  params: URLSearchParams | ReadonlyURLSearchParams,
) {
  const paramsString = params.toString()
  const queryString = `${paramsString.length ? '?' : ''}${paramsString}`

  return `${pathname}${queryString}`
}

export function getAbsoluteUrl(path: string) {
  return `${env.NEXT_PUBLIC_BASE_URL}${path}`
}
